<template>
  <section id="steps" class="flex overflow-hidden relative flex-wrap items-center w-full bg-lifeboost-red-lighter font-open-sans">
    <div class="pt-16 pb-6 mx-auto space-y-3.5 w-full text-center lg:space-y-5">

      <h2 class="px-4 text-3xl font-extrabold md:text-4xl xl:text-5xl font-ww-medium md:px-0" v-html="title"></h2>
      <p class="text-base md:text-lg lg:text-3xl" v-html="subTitle"></p>
    </div>

    <!--- In stock badge with text -->
    <div class="justify-center mx-auto w-full text-center font-body">
      <div class="inline-flex" v-html="status">
      </div>
      <div class="inline-flex items-center mx-1 rounded-full border-2 border-green-500">
        <svg role="presentation" class="m-2" data-name="Group 3452" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 19.622 19.622"> <circle id="Ellipse_67" data-name="Ellipse 67" cx="9.811" cy="9.811" r="9.811" transform="translate(0)" fill="#2da93e"></circle> <path id="Path_690" data-name="Path 690" d="M1691.839,1528.587l2.42,2.42,5.75-5.75" transform="translate(-1686.113 -1518.321)" fill="none" stroke="#fff" stroke-width="1"></path> </svg>
        <p class="mr-2">In stock</p></div>
      <div class="inline-flex" v-html="status2">
      </div>
    </div>
    <!--- hr -->
    <div class="py-6 w-full">
      <div class="mx-auto max-w-xs border-t-2 border-gray"></div>
    </div>

    <!--- Countdown -->
    <div class="flex flex-wrap justify-center items-center pb-16 mx-auto space-y-6 w-full text-6xl text-center md:space-x-4 md:space-y-0">
      <div class="flex justify-center w-full text-xl font-ww-medium md:justify-end md:w-4/12 xl:w-5/12"  v-html="timeText"></div>
      <div v-if="counter.days || counter.hours || counter.minutes || counter.seconds" class="flex justify-center w-full md:justify-start md:w-1/2 font-ww-medium">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" class="mr-2" viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path></svg>
        <div class="flex items-center mx-1 rounded-lg">
          <div class="text-xl leading-none sm:text-4xl md:text-4xl" set-day="">{{ counter.days }}</div>
          <div class="ml-2 text-base sm:text-2xl">days</div>
        </div>
        <div class="flex items-center mx-1 rounded-lg">
          <div class="text-xl leading-none sm:text-4xl md:text-4xl" set-hour="">{{ counter.hours }}</div>
          <div class="ml-2 text-base sm:text-2xl">hours</div>
        </div>
        <div class="flex items-center mx-1 rounded-lg">
          <div class="text-xl leading-none sm:text-4xl md:text-4xl" set-min="">{{ counter.minutes }}</div>
          <div class="ml-2 text-base sm:text-2xl">mins</div>
        </div>
        <div class="flex items-center mx-1 rounded-lg">
          <div class="text-xl leading-none sm:text-4xl md:text-4xl" set-sec="">{{ counter.seconds }}</div>
          <div class="ml-2 text-base sm:text-2xl">secs</div>
        </div>
      </div>
      <div v-else class="flex justify-center w-full md:justify-start md:w-1/2 font-ww-medium">
        EXPIRED
      </div>
    </div>

    <div class="w-full lg:w-5/12 lg:block">
      <div class="hidden relative h-full bg-white shadow-2xl carousel lg:block">
        <div class="overflow-hidden relative w-full h-full carousel-inner">

          <ClientOnly>
            <Swiper
                :class="''"
                :modules="[SwiperNavigation,SwiperPagination]"
                :slidesPerView="1"
                :spaceBetween="50"
                :loop="true"
                :navigation = "{
              nextEl: '.swiper-button-next-right',
    prevEl: '.swiper-button-prev--left'
            }"
                :pagination="{
      el: '.swiper-pagination',
      clickable: true,
    }"
                :breakpoints="{
              768: { slidesPerView: 1, },
            }">
              <SwiperSlide v-for="slide in slides" :key="slide.name">
                <div class="block w-full h-full max-h-[900px] text-5xl text-center text-white">
                  <nuxt-img
                      class="object-contain object-center w-full h-full"
                      loading="lazy"
                      format="webp"
                      width="460"
                      height="259"
                      :alt="slide.imgAlt"
                      sizes="sm:440px  md:100vw lg:100vw xl:460px"
                      :src="slide.imgSrc"
                  />


                </div>


              </SwiperSlide>

              <div class="swiper-pagination"></div>

              <label for="carousel-1" class="absolute inset-y-0 left-0 z-10 my-auto ml-2 w-10 h-10 text-2xl font-bold leading-tight text-center text-black bg-white rounded-full cursor-pointer prev swiper-button-prev--left hover:bg-lifeboost-red-500 control-2 md:ml-10 hover:text-white">‹</label>
              <label for="carousel-3" class="absolute inset-y-0 right-0 z-10 my-auto mr-2 w-10 h-10 text-2xl font-bold leading-tight text-center text-black bg-white rounded-full cursor-pointer next swiper-button-next-right control-2 hover:bg-lifeboost-red-500 md:mr-10 hover:text-white">›</label>


            </Swiper>

          </ClientOnly>

        </div>
      </div>
    </div>
    <div class="w-full lg:w-5/12 lg:hidden">
      <nuxt-img
                      class="block object-cover absolute w-full h-full opacity-10 lg:static lg:opacity-100"
                      loading="lazy"
                      format="webp"
                      width="460"
                      height="259"
                      alt="image coffee"
                      sizes="sm:440px  md:100vw lg:100vw xl:460px"
                      src="/assets/images/swiper-img-1.jpg"
                  />

  </div>
    <div data-option-section class="inset-0 mx-auto w-full lg:w-7/12 lg:bg-lifeboost-red-lighter">
    <!-- PRODUCT TABS -->
    <div class="px-2 pt-6 w-full md:px-5" id="first-class-swatch">
      <div class="mx-auto max-w-2xl counter-reset md:px-5 xl:max-w-3xl parent-element">
        <div class="counter-increment md:space-x-8">
          <h1
            class="flex-wrap py-3 pl-4 mb-2 text-2xl font-bold opacity-75 md:flex lg:text-3xl font-ww-medium"
            v-text="`${state.pageSteps.stepOne}`"
          >
            
          </h1>
          <!-- DESKTOP NAVIGATION -->
          <div class="grid grid-cols-2 gap-2 max-w-xs sm:grid-cols-4 sm:gap-4 sm:max-w-full">
            <div v-for="(item, index) in state.items">
              <button
                @click="setProduct(index)"
                :data-testid="'step1-choice-'+index"
                :class="state.active.items == index ? 'bg-white' : ''"
                type="button"
                class="grid relative justify-items-center px-2 py-4 w-full text-base rounded-md border border-gray-400 cursor-pointer hover:shadow-lg"
                data-product-selector=""
                data-product-title="Medium Roast"
                data-product-image="//cdn.shopify.com/s/files/1/0838/4525/files/Lifeboost_MediumRoastBean_Front.png?v=1636101840"
                data-product-desc="The healthiest, tastiest medium roast coffee possible. Enjoy our low-acid medium roast coffee."
                data-product-first="medium-roast"
                data-product-second="medium-roast"
              >
                <input type="radio" name="step1" class="hidden" checked="">

                <svg
                  role="presentation"
                  :class="state.active.items == index ? '' : 'opacity-0'"
                  class="absolute top-0 w-5 h-auto transition-opacity transform -translate-y-1/2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.622"
                  height="19.622"
                  viewBox="0 0 19.622 19.622"
                  ecl="true"
                >
                  <circle id="Ellipse_67" data-name="Ellipse 67" cx="9.811" cy="9.811" r="9.811" transform="translate(0)" fill="#fe3c38" ecl="true"></circle> <path id="Path_690" data-name="Path 690" d="M1691.839,1528.587l2.42,2.42,5.75-5.75" transform="translate(-1686.113 -1518.321)" fill="none" stroke="#fff" stroke-width="1" ecl="true"></path>
                </svg>
                <p class="inline-flex items-center mb-5 text-xs opacity-75 xl:text-sm font-ww-medium">
                  <span
                    :style="`background-color: ${getRoast(item.Name)}`"
                    class="flex justify-center items-center mr-2 w-3 h-4 rounded-full bg-lifeboost-yellow"
                  >
                    <svg
                      role="presentation"
                      xmlns="http://www.w3.org/2000/svg"
                      width="11.97"
                      height="12.367"
                      viewBox="0 0 11.97 12.367"
                    >
                      <path id="Path_662" data-name="Path 662" d="M7.519,0A4.709,4.709,0,0,0,4.293,2.1a5.369,5.369,0,0,0-.926,3.649A3.944,3.944,0,0,1,0,9.82,4.251,4.251,0,0,0,4.293,5.772S3.924,1.541,7.519,0Z" transform="matrix(-0.788, 0.616, -0.616, -0.788, 11.97, 7.738)" fill="#fff"></path>
                    </svg>
                  </span>
                  <span v-text="item.Name"></span>
                </p>
                <img :src="item.Image.formats.small.url" class="h-24">
              </button>
            </div>
          </div>
        </div>
        <div class="md:space-x-8 counter-increment">
          <h1
            v-text="`${state.pageSteps.stepTwo}`"
            class="flex-wrap py-3 pl-4 mb-2 text-2xl font-bold opacity-75 md:flex lg:text-3xl font-ww-medium"
          >
          </h1>
          <div class="flex gap-4 pt-2 pb-2 text-center">
            <template v-for="(item, index) in state.variants">
              <label
                role="button"
                tabindex="0"
                @click="setType(index)"
                :data-testid="'step2-choice-'+index"
                :class="state.active.variants == index ? 'bg-white' : ''"
                class="relative p-3.5 w-1/3 min-w-min font-medium rounded-lg border border-gray-400 duration-300 ease-out cursor-pointer hover:scale-110"
                data-option="item.Name.replace(' ','')"
              >
                <svg
                  class="absolute top-0 left-1/2 -mt-2.5 w-5 h-auto transition-opacity transform -translate-x-1/2"
                  :class="state.active.variants == index ? '' : 'opacity-0'"
                  xmlns="http://www.w3.org/2000/svg"
                  width="47.832"
                  height="47.832"
                  viewBox="0 0 47.832 47.832"
                >
                  <circle id="Ellipse_165" data-name="Ellipse 165" cx="23.916" cy="23.916" r="23.916" fill="#fe3c38"></circle>
                  <path id="Path_1024" data-name="Path 1024" d="M1691.839,1533.375l5.9,5.9,14.016-14.016" transform="translate(-1677.879 -1508.349)" fill="none" stroke="#fff" stroke-width="2"></path>
                </svg>
                <span
                  class="hidden absolute inset-0 -m-0.5 rounded-lg border-2 border-lifeboost-yellow-light bg-lifeboost-yellow-light show"
                  style="z-index: -1"
                ></span>
                <p class="text-base opacity-75 xl:text-lg font-ww-medium" v-text="item.Name"></p>
              </label>
            </template>
          </div>
        </div>
        <svg width="0" height="0" class="hidden">
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.099 19.261" id="star">
            <path d="M20.046 7.278a1.067 1.067 0 0 0-.919-.734l-5.8-.527L11.033.649a1.069 1.069 0 0 0-1.966 0L6.774 6.018l-5.8.527a1.07 1.07 0 0 0-.61 1.869l4.386 3.845-1.293 5.7a1.068 1.068 0 0 0 1.59 1.155l5-2.992 5 2.992a1.069 1.069 0 0 0 1.591-1.155l-1.293-5.7 4.39-3.845a1.07 1.07 0 0 0 .312-1.136Zm-9.9 8.783"></path>
          </symbol>
        </svg>
        <div class="counter-increment">
          <h1 v-if="state.pageSteps.stepThree"
            class="flex-wrap py-3 pl-4 mb-2 text-2xl font-bold opacity-75 md:flex lg:text-3xl font-ww-medium"
            v-text="`${replaceUnit(state.pageSteps.stepThree, state.variants[state.active.variants].Name.split(' ').join('').toLowerCase())}`"
          >

          </h1>
          <div class="flex flex-wrap justify-between pt-2 w-full text-center sm:px-5">
            <div class="flex flex-wrap justify-between p-0.5 mb-3 w-full rounded-md border border-gray-400 xl:mb-5">
              <div class="w-2/4" v-for="(item, index) in FilteredPacks">
                <label
                  @click="setPack(index)"
                  :data-testid="'step3-choice-'+index"
                  class="block relative order-2 p-2.5 font-medium cursor-pointer"
                  :data-index="index"
                  ><input
                    type="radio"
                    :value="index"
                    name="step3"
                    class="hidden"
                    v-model="state.active.packs" v-bind:id="index"
                  
                  >
                  <span class="absolute inset-0 z-0 bg-transparent rounded-md" :class="state.active.variants == packs ? 'showbg cath' : 'showbg cath'"></span>
                  <div class="relative text-lifeboost-red-400 showcolor-white">
                    <p
                      class="text-sm font-bold uppercase md:text-base xl:text-lg font-ww-medium"
                      v-text="item.Name"
                    ></p>
                  </div>
                </label>
              </div>
            </div>
            <div class="flex flex-row w-full">
              <div class="w-1/2" v-for="(item, index) in FilteredPacks">
                <div
                  class="flex flex-col px-2.5 text-sm tracking-tight text-left text-gray-500 xl:w-auto 2xl:px-8 lg:text-base xl:text-lg"
                  v-html="item.Offer"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-12 mx-auto max-w-2xl text-center md:px-5 xl:max-w-3xl">
        <button
          @click="addToCart($event)"
          data-testid="cta-button"
          class="relative py-3 w-10/12 text-sm whitespace-nowrap cursor-pointer btn-red xl:text-2xl md:text-xl font-ww-medium" style="font-family: WigrumWebMedium !important"
        >
          Add To Cart
          <svg
            class="absolute inset-y-0 right-4 my-auto w-auto md:right-6 lg:h-4 xl:h-auto"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 16 29"
            width="16px"
            height="29px"
          >
            <path fill-rule="evenodd"  fill="rgb(255, 255, 255)"
            d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z"/>
          </svg>
        </button>
        <p class="pt-2 text-sm text-center">30-DAY 100% MONEY-BACK GUARANTEE</p>
        <img src="//lifeboostcoffee.com/cdn/shop/t/173/assets/pay.png?v=153152236212424935581663902438" class="pt-2.5 mx-auto max-w-xs mix-blend-darken">
      </div>
    </div>

  </div>
  <div class="relative flex items-center justify-center customPopup2 fixed w-full h-full z-[999] left-0 top-0"
    v-show="state.upgrade.show" :class="state.upgrade.show ? 'active' : ''" id="tail">
    <div id="modal_1"
      class="flex overflow-scroll fixed top-0 z-50 items-center w-full h-screen bg-gray-800 bg-opacity-50 sm:overflow-hidden">
      <div
        class="flex justify-center items-center px-4 py-20 w-full max-w-6xl 2xl:mx-auto md:px-20 xs-max:relative xs-max:top-36">
        <div
          class="flex relative flex-col justify-center items-center px-4 py-14 w-full max-w-screen-lg bg-white border-t-8 border-yellow-600 shadow-lg md:w-auto lg:px-12 xl:px-16">
          <div class="w-full modal-header">
            <div class="flex justify-between mb-2 space-x-3 w-full text-sm font-semibold">
              <div class="item">Add to Cart</div>
              <div class="text-center item sm:text-left">Upgrade Options</div>
              <div class="text-right item">Secure Checkout</div>
            </div>
            <div class="mb-6 w-full progress progress-striped active">
              <div class="progress-bar progress-bar-success" :class="modal.crosssell.show ? 'w-3/4' : 'w-1/2'">
                <span>&nbsp;</span>
              </div>
            </div>
          </div>
          <!-- modal body 1 start -->
          <div class="w-full modal-body" v-show="modal.upsell.show">
            <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
              <p class="m-0 text-lg lg:text-lg xl:text-xl" v-text="state.upgrade.UpSell.PreHeader"></p>
              <p class="m-0 mx-auto w-full text-lg font-bold text-center uppercase opacity-75 md:w-4/5 sm:text-2xl md:text-3xl lg:text-4xl font-ww-medium"
                v-text="state.upgrade.UpSell.Header"></p>
            </div>
            <div class="flex items-center px-0 mt-10 space-x-4 md:space-x-8">
              <div class="w-8/12 h-auto item md:w-2/3">
                <h1 role="main" class="text-2xl font-semibold leading-7 text-left text-gray-800 lg:text-3xl lg:leading-9">
                  Lucky You!
                </h1>
                <div data-body-copy>
                  <!-- You’ve found our
    <span class="italic">New Customer Special</span> - our
    biggest savings anywhere in our store. -->
                  <p class="mt-2 text-lg font-normal text-justify sm:text-xl" v-text="state.upgrade.UpSell.SubHeader"></p>
                  <!-- <p v-if="state.upgrade.Discount" class="mt-2 text-lg font-normal sm:text-xl" v-html="state.upgrade.Discount"></p> Todo: Fix this: Enable and check Healthy Coffee 23 in sale stack -->
                </div>
              </div>
              <div class="w-4/12 h-auto item md:w-1/3">
                <img class="mx-auto" loading="lazy" :src="state.upgrade.UpSell.Image" />
              </div>
            </div>
            <div class="space-y-3 w-full text-center sm:px-5 md:space-y-4">
              <a @click="setChoice(true)" class="btn--special">Yes!
                Upgrade My Savings
                <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 29"
                  width="16px" height="29px">
                  <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                    d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                  </path>
                </svg>
              </a>
            </div>
            <a @click="setChoice(false)" href="javascript:void(0)"
              class="block text-base leading-none text-center text-gray-800 border-b border-transparent focus:outline-none">No
              thanks, I’ll pass on this one-time offer</a>
            <button @click="setChoice(false)"
              class="absolute top-4 right-4 text-gray-800 cursor-pointer lg:top-6 lg:right-6 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              aria-label="close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                ...
              </svg>
            </button>
          </div>
          <!-- modal body 1 end -->
          <!-- modal body 2 start -->
          <div class="w-full modal-body" v-show="modal.crosssell.show">
            <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
              <!-- Save $30 When You Add Our
                  <span class="italic">Signature Roast Bundle</span> to Your Order -->
              <p class="px-2 m-0 mx-auto text-lg font-bold text-center uppercase opacity-75 sm:text-2xl md:text-3xl lg:text-3xl font-ww-medium"
                v-text="state.upgrade.CrossSell.Header"></p>
            </div>
            <div class="flex items-center px-2 mt-10 space-x-4 md:space-x-8">
              <div class="w-8/12 h-auto item md:w-2/3">
                <!-- Try all three of our most popular roasts at a huge discount.
                  Enjoy our delicious organic Medium Roast, Dark Roast, and
                  Espresso Roast. All are shade grown, high-elevation grown,
                  tested for over 400 toxins, low acid, and d-e-l-i-c-i-o-u-s! -->
                <p class="mt-2 text-lg font-normal text-justify sm:text-xl" v-text="state.upgrade.CrossSell.Body"></p>
                <!-- <s>$104.85</s> $74.85
                  <strong class="italic">(Save $30!)</strong> -->
                <p class="mt-2 text-lg font-normal sm:text-xl" v-html="state.upgrade.CrossSell.PricenSave"></p>
              </div>
              <div class="w-4/12 h-auto item md:w-1/3">
                <img class="mx-auto" loading="lazy" :src="state.upgrade.CrossSell.Image" />
              </div>
            </div>
            <div class="px-5 space-y-3 w-full text-center md:space-y-4">
              <a @click="setChoice(true)" data-add-upgrade-bundle class="btn--special">Yes!
                Upgrade My Order
                <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 29"
                  width="16px" height="29px">
                  <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                    d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                  </path>
                </svg>
              </a>
            </div>
            <a @click="setChoice(false)" data-add-default-final href="javascript:void(0)"
              class="block text-sm leading-none text-center text-gray-800 border-b border-transparent focus:outline-none">
              No thanks, I’ll pass on this opportunity to try these three roasts
              at a big discount…
            </a>
            <button @click="setChoice(false)"
              class="absolute top-6 right-6 text-gray-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              aria-label="close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                ...
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </section>
</template>

<script setup>
import Engine from "~/composables/Engine.js";

const props = defineProps({
  title: {
    type: String,
    default: 'GET UP TO <u>58% OFF</u> YOUR ORDER -\n' +
        '        WHILE SUPPLIES LAST!',
  },
  subTitle: {
    type: String,
    default: '(WE’LL EVEN PAY FOR THE SHIPPING!)',
  },
  status: {
    type: String,
    default: 'Current status:',
  },
  status2: {
    type: String,
    default: 'Your order will ship today.',
  },
  timeText: {
    type: String,
    default: 'Hurry, this deal ends in:',
  },
  slides: {
    type: Array,
    default: () => [
      {
        imgSrc: "assets/images/swiper-img-1.jpg",
        imgAlt: "image 1",
      },
      {
        imgSrc: "assets/images/swiper-img-2.jpg",
        imgAlt: "image 2",
      },
      {
        imgSrc: "assets/images/swiper-img-3.jpg",
        imgAlt: "image 3",
      },
      {
        imgSrc: "assets/images/swiper-img-4.jpg",
        imgAlt: "image 4",
      },
    ],
  },
});
// counter
const counter = ref({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});




const runEngine = new Engine();
const route = useRoute();
const page = ref({ Products: { data: {} }, AOVBooster: [], PreselPack: null });
page.value = await runEngine.queryPage(
  route.path.split("/").at(-1).split("?")[0]
);
const products = computed(() => {
  return Object.keys(page.value.Products).reduce(
    (r, v) => ({ ...r, [v]: page.value.Products[v] }),
    {}
  );
});

const upgrades = computed(() =>
  page.value.AOVBooster.length ? page.value.AOVBooster[0] : []
);
const Preselected = computed(() =>
  page.value.PreselPack !== null ? page.value.PreselPack - 1 : 0
);

const highlightCheckbox = ref(false);
const checkboxChecked = ref(false);

const state = reactive({
  layout: ref(""),
  layoutPopup: ref(""),
  subscriptionPage: ref(false),
  pageSteps: ref({
          stepOne: page.value.step1,
          stepTwo: page.value.step2,
          stepThree: page.value.step3,
        }),
  items: products,
  upgrades: upgrades,
  variants: products.value[0].Variants,
  packs: products.value[0].Variants[0].Pack.filter((obj) => obj.Active),
  images: products.value[0].Variants[0].variant.Gallery[0],
  unit: {
    beans: ["bag", "bags"],
    pods: ["box", "boxes"],
    ground: ["bag", "bags"],
    wholebeans: ["bag", "bags"],
    coffeeground: ["bag", "bags"],
    coffeebeans: ["bag", "bags"],
    coffeepods: ["box", "boxes"],
    groundcoffee: ["bag", "bags"],
  },
  currentUnit: ref(["bag", "bags"]),
  active: {
    items: 0,
    variants: 0,
    packs: Preselected.value,
    sellingPlan: 0,
  },
  upgrade: ref({
    UpSell: {},
    CrossSell: {},
    show: false,
  }),
  isSubscription: page.value.Subscription ?? false,
  regular: ref({}),
  trackingStack: ref({}),
});

const FilteredPacks = computed(() => {
  return state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);
});
// Modal object
const modal = reactive({
  show: true,
  page: true,
  product: {
    qty: 0,
    packName: "",
    Coupon: [],
    variantID: 40029155524668,
  },
  upsell: {
    show: true,
    activate: false,
  },
  crosssell: {
    show: false,
    variantId: 32453656150076,
    activate: false,
  },
});

// const setProduct = (index) => {
//   const newPacks = products.value[index].Variants[0].Pack.filter((obj) => obj.Active);
// state.packs.splice(0, state.packs.length, ...newPacks);
//     }
// console.log(modal.upsell.show);
// Methods
const setProductModal = (input) => {
  modal.product = {
    qty: input.qty,
    packName: input.packName,
    Coupon: input.Coupon,
    variantID: input.variantID,
  };
  modal.crosssell.variantId = input.crossSellID;
};

const trackEvent = inject("trackEvent");

const setProduct = (index) => {
  index = parseInt(index);
  state.variants = products.value[index].Variants;
  state.active.items = parseInt(index);
  state.packs = products.value[index].Variants[0].Pack.filter(
    (obj) => obj.Active
  );
  state.images =
    products.value[index].Variants[0].variant.Gallery[0];
  state.active.variants = 0;
  state.active.packs = parseInt(Preselected.value);

};
const setType = (index) => {
  state.active.variants = parseInt(index);

  state.images =
    state.items[state.active.items].Variants[
      state.active.variants
    ].variant.Gallery[0];
  state.active.packs = parseInt(Preselected.value);
  state.packs = state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);
};

const setPack = (index) => {
  state.active.packs = parseInt(index);
};
const getRoast = (str) => {
  str = str.toLowerCase()
  return str.includes('light') ? '#edd596' : str.includes('medium') ? '#a9a93d' : str.includes('dark') ? '#505011' : str.includes('decaf') ? '#c19862' : '#edd596'
}
const activePack = (index) => {
  return state.active.packs === index;
};
const setChoice = (choice) => {
  if (modal.upsell.show === true) {
    modal.upsell.activate = choice;

    // track upsell offer decision
    if (choice) {
      trackOffer.accept({
        id: 1,
        name: 'Double Order Upsell'
      });
    } else {
      trackOffer.decline({
        id: 1,
        name: 'Double Order Upsell'
      });
    }

    modal.upsell.show = false;
    modal.crosssell.show = true;

    // track cross-sell view
    trackOffer.view({
      id: 2,
      name: 'Signature Bundle Cross-sell' // Double Order or Signature Bundle
    });
  } else if (modal.crosssell.show === true) {

    modal.crosssell.activate = choice;

    // track cross-sell offer decision
    if (choice) {
      trackOffer.accept({
        id: 2,
        name: 'Signature Bundle Cross-sell'
      });
    } else {
      trackOffer.decline({
        id: 2,
        name: 'Signature Bundle Cross-sell'
      });
    }
   checkOut();
  }
};


const checkOut = () => {
  const crossSellId = modal.crosssell.activate && modal.crosssell.variantId;
  runEngine.checkout(
    modal.product.variantID,
    modal.upsell.activate ? modal.product.qty * 2 : modal.product.qty,
    modal.upsell.activate ? modal.product.Coupon[0] : modal.product.Coupon[1],
    modal.product.packName,
    null,
    crossSellId,
    trackEvent
  );

};

const replaceUnit = (str, convert) => {
  const units = state.currentUnit
  const toConverts = state.unit[convert]
  const unitsCapital = units.map(unit => unit.charAt(0).toUpperCase() + unit.slice(1))
  const toConvertCapital = toConverts.map(unit => unit.charAt(0).toUpperCase() + unit.slice(1))
  state.currentUnit = state.unit[convert]
  return str.replaceAll(new RegExp(`${unitsCapital[1]}`, 'g'), toConvertCapital[1]).replaceAll(new RegExp(`${unitsCapital[0]}`, 'g'), toConvertCapital[0]).replaceAll(new RegExp(`${units[1]}`, 'g'), toConverts[1]).replaceAll(new RegExp(`${units[0]}`, 'g'), toConverts[0])
}

const setProductDetails = (index) => {
  index = parseInt(index);
  state.variants = products.value[index].Variants;
  state.active.items = index;
  state.packs = products.value[index].Variants[0].Pack.filter(
    (obj) => obj.Active
  );
  state.images =
    products.value[index].Variants[0].variant.Gallery[0];
  state.active.variants = 0;
  state.active.packs = Preselected.value;
};

const setPrice = (item) => {
  const amount = item.PackSize.replace("x", "");
  const sale =
    state.variants[state.active.variants].variant.VariantPrice;
  return "$" + (amount * sale).toFixed(2);
};

const addUpgradeToCart = (accepted) => {
  accepted ? onCheckout(state.upgrade) : onCheckout(state.regular);
};

const onCheckout = (Item) => {
  runEngine.checkout(
    Item.varID,
    Item.quantity,
    Item.Coupon,
    Item.pack,
    null,
    null,
    trackEvent
  );
};

const stockCheck = () => {
  return state.items[state.active.items].Variants[state.active.variants].variant
    .inStock;
};

const hasSellingPlans = () => {

  return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans.length > 0;
}
// gid://shopify/SellingPlan/970981436
const getSellingPlan = () => {
  // return the last selling plan id example from gid://shopify/SellingPlan/970981436 return only 970981436
  return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans[state.active.sellingPlan].sellingPlan.id.split("/").at(-1);
}

const getStep = (step) => {
  switch (step) {
    case 1:
      return "Step 1";
    case 2:
      return Object.keys(state.items).length > 1 ? "Step 2" : "Step 1";
    case 3:
      return Object.keys(state.items).length > 1 && state.variants.length > 1
        ? "Step 3"
        : Object.keys(state.items).length > 1 || state.variants.length > 1
          ? "Step 2"
          : "Step 1";
    default:
      return "";
  }
};

// Lifecycle hook onMounted (equivalent to init in Alpine.js)
onMounted(() => {
  runEngine.fetchProduct(["6938980876348", "6980372004924", "7148455624764", "8023271014460"]).then(() => {
    Object.keys(state.items).map((key) => {
      return state.items[key].Variants.map((variant, index) => {
        state.items[key].Variants[index].variant.inStock =
          runEngine.getInStock(variant.variant.VariantID);
        state.items[key].Variants[index].variant.SellingPlans =
          runEngine.getVariant(variant.variant.VariantID).sellingPlanAllocations.nodes;
      });
    });
  });


const today = new Date()
const tomorrow = new Date(today)
tomorrow.setDate(tomorrow.getDate() + 1)
tomorrow.setHours(0, 0, 0, 0)
const countDownDate = new Date(tomorrow).getTime()
const x = setInterval(() => {
  const now = new Date().getTime()
  const distance = countDownDate - now
  const days = Math.floor(distance / (1000 * 60 * 60 * 24))
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((distance % (1000 * 60)) / 1000)
  counter.value.days = days
  counter.value.hours = hours
  counter.value.minutes = minutes
  counter.value.seconds = seconds
  if (distance < 0) {
    clearInterval(x)
  }
}, 1000)
});
const addToCart = () => {
  const item = state.items[state.active.items];
  const variant = item.Variants[state.active.variants];
  const pack = variant.Pack[state.active.packs];
  const variantID = variant.variant.VariantID;

  if (typeof state.upgrades.CrossSellOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter(
      (obj) => obj.PackSize === "x" + pack.PackSize.replace("x", "") * 2
    );
    const oferTa = upgradeOffer[0] ? upgradeOffer[0] : pack;
    const CrossSellVariant = JSON.parse(
      state.upgrades.CrossSellOffer.VariantId.VariantSKU
    )[variant.Name.toLowerCase().includes("bean") ? "beans" : "ground"];
    setProductModal({
      qty: pack.PackSize.replace("x", ""),
      packName: pack.Name,
      Coupon: [oferTa.Coupon, pack.Coupon],
      variantID: variantID,
      crossSellID: CrossSellVariant,
    });
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: pack.PackSize.replace("x", "") * 2,
      PackDiff: pack.PackSize.replace("x", "") / 2,
      UpSell: {
        PreHeader: state.upgrades.UpsellOffer.PreHeader,
        Header: state.upgrades.UpsellOffer.Header,
        SubHeader: state.upgrades.UpsellOffer.SubHeader,
        Image: state.upgrades.UpsellOffer.Image.url,
        ButtonText: "Yes! Upgrade My Order",
      },
      CrossSell: {
        Body: state.upgrades.CrossSellOffer.Body,
        Header: state.upgrades.CrossSellOffer.Header,
        Image: state.upgrades.CrossSellOffer.Image.url,
        PricenSave: state.upgrades.CrossSellOffer.PricenSave,
        ButtonText: "Yes! Upgrade My Order",
      },
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      show: true,
    };
  } else if (typeof state.upgrades.UpsellPackOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const xUpgradeQty = state.upgrades.UpsellPackOffer.filter(
      (obj) => obj.PackSizeRun === pack.PackSize
    );
    const oferTi = xUpgradeQty[0];
    
    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter((obj) => obj.PackSize === oferTi.PackUpgrade);
    const oferTa = upgradeOffer[0] ? upgradeOffer[0] : pack;
    if (state.layoutPopup == "L02") {
      setProductModal({
        qty: pack.PackSize.replace("x", ""),
        packName: pack.Name,
        Coupon: [oferTa.Coupon, pack.Coupon],
        variantID: variantID,
      });
    }
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: oferTi.PackUpgrade.replace("x", ""),
      PackDiff:
        oferTi.PackUpgrade.replace("x", "") -
        oferTi.PackSizeRun.replace("x", ""),
      PreHeader: oferTi.PreHeader,
      Header: oferTi.Header,
      SubHeader: oferTi.SubHeader,
      Image: oferTi.Image.url,
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      ButtonText: oferTi.ButtonText,
      show: true,
    };
    state.regular = {
      product: item.Name,
      variant: variant.Name,
      pack: pack.Name,
      quantity: pack.PackSize.replace("x", ""),
      Coupon: pack.Coupon,
      varID: variantID,
    };
  } else if (state.isSubscription && hasSellingPlans()) {
    runEngine.checkout(
      variantID,
      pack.PackSize.replace("x", ""),
      pack.Coupon,
      pack.Name,
      getSellingPlan(),
      null,
      trackEvent
    );
  } else {
    runEngine.checkout(
      variantID,
      pack.PackSize.replace("x", ""),
      pack.Coupon,
      pack.Name,
      null,
      null,
      trackEvent
    );
  }
};

const handleButtonClick = () => {
  if (!checkboxChecked.value && state.isSubscription) {
    highlightCheckbox.value = true;
  } else {
    addToCart();

    // track upsell offer view
    trackOffer.view({
      id: 1,
      name: 'Double Order Upsell' // Double Order or Signature Bundle
    });

  }
};



defineBuilderComponent({
    friendlyName: "SwatchesType2",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "GET UP TO <u>58% OFF</u> YOUR ORDER -\n WHILE SUPPLIES LAST!"
        },
        {
            name: "subTitle",
            type: "string",
            defaultValue: "(WE’LL EVEN PAY FOR THE SHIPPING!)"
        },
        {
            name: "status",
            type: "string",
            defaultValue: "Current status:"
        },
        {
            name: "status2",
            type: "string",
            defaultValue: "Your order will ship today."
        },
        {
            name: "timeText",
            type: "string",
            defaultValue: "Hurry, this deal ends in:"
        },
        {
            name: "slides",
            type: "list",
            defaultValue: [
                {
                    imgSrc: "assets/images/swiper-img-1.jpg",
                    imgAlt: "image 1"
                },
                {
                    imgSrc: "assets/images/swiper-img-2.jpg",
                    imgAlt: "image 2"
                },
                {
                    imgSrc: "assets/images/swiper-img-3.jpg",
                    imgAlt: "image 3"
                },
                {
                    imgSrc: "assets/images/swiper-img-4.jpg",
                    imgAlt: "image 4"
                }
            ],
            subFields: [
                {
                    name: "imgSrc",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png"
                    ],
                    required: true
                },
                {
                    name: "imgAlt",
                    type: "string"
                }
            ]
        }
    ]
});
</script>

<style scoped>

.swiper-pagination-bullet-active {
  background: #ef4444 !important;
}

.swiper-pagination-bullet {
  background: white;
  opacity: 1;
}

.counter-reset .counter-increment {
    position: relative;
    padding-left: 45px;
}

.parent-element {
  counter-reset: section 0; /* Start counting from 1 */
}

.counter-reset .counter-increment:before {
    counter-increment: section;
    content: counter(section);
    position: absolute;
    left: 0;
    top: 10px;
    width: 45px;
    height: 45px;
    line-height: 40px;
    border: 2px solid #5a3b36;
    text-align: center;
    border-radius: 45px;
    color: #5a3b36;
    font-size: 24px;
}



label input:checked~.showbg.cath {
    --tw-bg-opacity: 1;
    background-color: rgba(113,63,18,var(--tw-bg-opacity));
}
label input:checked~.showbg {
    --tw-border-opacity: 1;
    border-color: rgba(255,255,255,var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(255,255,255,var(--tw-bg-opacity));
}

label input:checked~.showcolor-white {
    --tw-text-opacity: 1;
    color: rgba(255,255,255,var(--tw-text-opacity));
}

.counter-increment {
  position:relative
}

.counter-increment:after {
    content: "";
    position: absolute;
    height: calc(100% - 63px);
    left: 22.5px;
    bottom: 0;
    border-left: 1px solid #000;
}



</style>